import * as React from 'react';

const Menu24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1 4.75c0 .414.336.75.75.75h20.5a.75.75 0 0 0 0-1.5H1.75a.75.75 0 0 0-.75.75M1 12a.75.75 0 0 1 .75-.75h20.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 12m0 7.25a.75.75 0 0 1 .75-.75h20.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1-.75-.75"
  }
));
Menu24.Size = 24;
Menu24.Title = "Menu";

export { Menu24 as default };
